<template>
  <div class="myAtlas">
    <!-- 筛选区 -->
    <div class="filterArea" />

    <!-- 主体 -->
    <div v-if="activer === 'mainAtlas'" class="myAtlas_box">
      <div class="queryArea">
        <el-input v-model="parameter.keyword" placeholder="请输入标题/appid" class="queryArea_input" />
        <el-select
          v-model="parameter.platformId"
          class="launch"
          filterable
          placeholder="选择平台"
        >
          <el-option
            v-for="item in platforms"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          style="margin-left:10px"
          @click="search"
        >搜索</el-button>
        <el-button
          type="primary"
          icon="el-icon-refresh"
          @click="reset"
        >重置</el-button>
      </div>
      <ul v-loading="loading" class="box_ul">
        <li v-for="item in datas" :key="item.id" class="ul_li" :class="{active:actives.filter(id => +item.id === +id).length}" @click="change(item)">
          <!-- <img class="li_img" :src="item.coverImgPath"> -->
          <el-image
            style="width: 100px; height: 100px"
            :src="item.coverImgPath"
            fit="cover"
          />
          <!-- <span class="li_text">{{ item.title }}</span> -->
          <el-popover
            placement="top-start"
            title="标题"
            width="200"
            trigger="click"
            :content="item.title"
          >
            <p slot="reference" class="titip">{{ item.title }}</p>
          </el-popover>
          <i v-if="actives.filter(id => +item.id === +id).length" class="el-icon-check" />
        </li>
      </ul>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>

    <!-- 子体 -->
    <div v-if="activer === 'subgraphSet'" class="myAtlas_box">
      <!-- 查询区内容 -->
      <div class="queryArea">
        <el-input v-model="parameters.title" placeholder="标题" class="queryArea_input" />
        <!-- <el-input v-model="parameters.novelTitle" placeholder="书名" class="queryArea_input" /> -->
        <el-select
          v-model="parameters.isOpen"
          class="launch"
          filterable
          placeholder="是否公开"
        >
          <el-option
            v-for="item in platformssew"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          style="margin-left:10px"
          @click="serach"
        >搜索</el-button>
        <el-button
          type="primary"
          icon="el-icon-refresh"
          @click="resetdaw"
        >重置</el-button>
      </div>
      <ul class="box_ul">
        <li v-for="item in datasr" :key="item.id" class="ul_li" :class="{active:activesrrr.filter(id => +item.id === +id).length}" @click="changer(item)">
          <!-- <img class="li_img" :src="item.coverPicturePath"> -->
          <el-image
            style="width: 100px; height: 100px"
            :src="item.coverPicturePath"
            fit="cover"
          />
          <!-- <span class="li_text">{{ item.title }}</span> -->
          <el-popover
            placement="top-start"
            title="标题"
            width="200"
            trigger="click"
            :content="item.title"
          >
            <p slot="reference" class="titip">{{ item.title }}</p>
          </el-popover>
          <i v-if="activesrrr.filter(id => +item.id === +id).length && item.granted == false" class="el-icon-check" />
          <i v-if="item.granted == true" class="el-icon-remove" />
        </li>
      </ul>
      <pagination-right
        :total="totalr"
        @size-change="fetchPageSizer"
        @current-change="fetchCurrentPager"
      />
    </div>

    <div class="buttonArea" @click="determine">
      <el-button type="primary">确 定</el-button>
    </div>
  </div>
</template>

<script>
import { atlaslist, atlasdeletesew, customerservice, strategyPlatform } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  props: {
    activeItem: {
      type: Object,
      default() {
        return {}
      }
    },
    activer: {
      type: String,
      default: ''
    }

  },
  data() {
    return {
      loading: false,
      platforms: [], // 平台数据
      platformssew: [
        {
          name: '全部',
          id: ''
        }, {
          name: '不公开',
          id: 1
        },
        {
          name: '公开',
          id: 2
        }], // 平台数据
      total: null, // 总页数
      totalr: null,
      checked: true,
      actives: [],
      activesrrr: [],
      datas: [],
      datasr: [],
      parameter: {
        page: 1,
        pageSize: 10,
        keyword: null,
        platformId: null
      }, // 参数
      parameters: {
        page: 1,
        pageSize: 10,
        title: null,
        novelTitle: null,
        isOpen: ''
      } // 参数
    }
  },
  created() {
    this.strategylist()
    console.log('222', this.activeItem, this.activer)
    if (this.activer === 'mainAtlas') {
      console.log('mainAtlas')
      this.gedrw()
    } else {
      console.log('subgraphSet')
      this.gedrwr()
    }
  },
  methods: {
    // 获取策略列表
    async strategylist() {
      const data = await strategyPlatform()
      this.platforms = data.data.list
      console.log('data', data)
    },
    change(item) {
      const index = this.actives.findIndex(id => +item.id === +id)
      index !== -1 ? this.actives.splice(index, 1) : this.actives.push(item.id)
      console.log('this.actives', this.actives)
    },
    changer(item) {
      // eslint-disable-next-line eqeqeq
      if (item.granted == true) {
        return
      }
      const index = this.activesrrr.findIndex(id => +item.id === +id)
      index !== -1 ? this.activesrrr.splice(index, 1) : this.activesrrr.push(item.id)
      console.log('this.activesrrr', this.activesrrr)
    },
    // 分页
    fetchPageSize(e) {
      this.parameter.pageSize = e
      this.gedrw()
    },
    fetchCurrentPage(e) {
      this.parameter.page = e
      this.gedrw()
    },
    // 分页
    fetchPageSizer(e) {
      this.parameters.pageSize = e
      this.gedrwr()
    },
    fetchCurrentPager(e) {
      this.parameters.page = e
      this.gedrwr()
    },
    // 主请求列表接口
    async gedrw() {
      // this.loading = true
      const data = await atlaslist({
        page: this.parameter.page,
        pageSize: this.parameter.pageSize,
        openId: this.activeItem.openId,
        keyword: this.parameter.keyword,
        platformId: this.parameter.platformId
      })
      this.datas = data.data.list
      this.total = data.data.total
      // this.loading = false
      console.log('data', data)
    },
    // 子请求列表接口
    async gedrwr() {
      const data = await atlasdeletesew({
        page: this.parameters.page,
        pageSize: this.parameters.pageSize,
        openId: this.activeItem.openId,
        title: this.parameters.title,
        novelTitle: this.parameters.novelTitle,
        isOpen: this.parameters.isOpen
      })
      this.datasr = data.data.list
      this.totalr = data.data.total
      console.log('data', data)
    },
    // 确定
    async determine() {
      if (this.activer === 'mainAtlas') {
        // 主的
        if (this.actives.length === 0) {
          this.$message.error('请选择')
          return
        }
        console.log('this.actives', this.actives.toString())
        const data = await customerservice({
          atlasIds: this.actives.toString(),
          openId: this.activeItem.openId,
          grantType: 2
        })
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.gedrw()
        this.actives = []
        this.$emit('close')
        console.log('data', data)
      } else {
        // 次的
        if (this.activesrrr.length === 0) {
          this.$message.error('请选择')
          return
        }
        console.log('this.activesrrr', this.activesrrr)
        const data = await customerservice({
          atlasInfoId: this.activesrrr.toString(),
          openId: this.activeItem.openId,
          grantType: 2
        })
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.gedrwr()
        this.activesrrr = []
        this.$emit('close')
        console.log('data', data)
      }
    },
    // 重置
    reset() {
      this.parameter.page = 1
      this.parameter.pageSize = 10
      this.parameter.keyword = null
      this.parameter.platformId = null
      this.gedrw()
    },
    // 搜索
    search() {
      this.parameter.page = 1
      this.parameter.pageSize = 10
      this.gedrw()
    },
    serach() {
      this.parameters.page = 1
      this.parameters.pageSize = 10
      this.gedrwr()
    },
    resetdaw() {
      this.parameters.page = 1
      this.parameters.pageSize = 10
      this.parameters.title = null
      this.parameters.novelTitle = null
      this.parameters.isOpen = ''
      this.gedrwr()
    }
  }
}
</script>

<style scoped>
.myAtlas{
     width: 100%;
     height: 500px;
}
ul,li{
  margin: 0px;
  /* padding: 0px; */
  list-style-type:none;

}
.myAtlas_box{

}

.box_ul{
padding: 3px 7px;
display: flex;
flex-wrap: wrap;
margin-top: 20px;
}

.ul_li{
  /* width: 119px; */
  display: flex;
  flex-direction: column;
  cursor: pointer;
  position: relative;
  margin-right: 15px;
}

.ul_li.active{
  box-shadow: 0px 0px 7px rgb(11, 194, 93);
}

.ul_li .el-icon-check{
    position: absolute;
    bottom: 44px;
    right: 6px;
    font-size: 24px;
    color: rgb(11, 194, 93);
    background-color: #fff;
    border-radius: 3px;
    border: 1px solid;
}
.ul_li .el-icon-remove{
    position: absolute;
    bottom: 44px;
    right: 6px;
    font-size: 24px;
    color: #ccc;
    background-color: #fff;
    border-radius: 3px;
    border: 1px solid;
}

.ul_li:not(.active):hover{
  box-shadow: 0px 0px 7px black;
}

.li_img{
   width: 100%;
}

.li_text{
  /* position: absolute; */
    font-size: 16px;
    margin-top: 10px;
    /* bottom: 0px; */
}

.ul_li .el-checkbox{
  position: absolute;
  bottom: 2px;
  right: 7px;
}
.buttonArea{
  display: flex;
  justify-content: flex-end;
}
.titip{
    width: 100%;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 这里是超出几行省略 */
    overflow: hidden;
}
.queryArea_input{
  width: 200px;
  margin-right: 10px;
}
</style>
